import { cn } from '@/lib/utils';
import { Skeleton } from '../Skeleton';
import { ShapeGroup } from './ShapeGroup';

const LABEL_WIDTHS = ['25%', '32%', '20%', '28%'];

interface FormSkeletonProps {
  fields?: number;
  /** A full-width action under the fields. Default true. */
  submit?: boolean;
  /** Announced instead of Common.loading, e.g. "Checking your profile". */
  label?: string;
  className?: string;
}

/** A label line over an input-height block per field, then one action. */
export function FormSkeleton({ fields = 4, submit = true, label, className }: FormSkeletonProps) {
  return (
    <ShapeGroup label={label} className={cn('space-y-6', className)}>
      {Array.from({ length: fields }, (_, i) => (
        <div key={i} data-skeleton-field="" className="space-y-2">
          <Skeleton.Line width={LABEL_WIDTHS[i % LABEL_WIDTHS.length]} />
          <Skeleton.Block height={40} />
        </div>
      ))}
      {submit && <Skeleton.Block height={44} />}
    </ShapeGroup>
  );
}
